import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import './About.css'

const About = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-100px" })

  // Calculate years of experience from earliest work date
  const calculateYearsExperience = () => {
    const earliestDate = new Date('November 1, 2020') // neTTaxi start date
    const currentDate = new Date()
    const years = Math.floor((currentDate - earliestDate) / (1000 * 60 * 60 * 24 * 365.25))
    return years
  }

  const yearsExperience = calculateYearsExperience()

  return (
    <section id="about" className="about" ref={ref}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="section-header"
        >
          <h2 className="section-title">
            About <span className="gradient-text">Me</span>
          </h2>
          <p className="section-subtitle">
            Passionate React Native developer creating amazing mobile experiences
          </p>
        </motion.div>

        <div className="about-content">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="about-text"
          >
            <p>
              I'm a passionate React Native developer and entrepreneur with over 4 years of experience 
              building production-ready mobile applications. As a Co-Founder & CTO, I've led the 
              development of <strong>TookLook</strong> from concept to launch, creating a comprehensive 
              appointment scheduling platform used by service providers and clients.
            </p>
            <p>
              I've developed and published <strong>10+ mobile apps</strong> across diverse industries - 
              from social networking and dating platforms to delivery services, health & fitness, 
              lifestyle applications, and Minecraft content marketplaces. My expertise extends to 
              <strong>AI-powered solutions</strong>, having integrated artificial intelligence into 
              <strong>Muna Astrology</strong> for personalized horoscope insights and <strong>AiFit</strong> 
              for intelligent food recognition and nutrition tracking.
            </p>
            <p>
              Beyond mobile apps, I'm an active open-source contributor with <strong>2 published npm 
              packages</strong> that help the React Native community. I specialize in real-time 
              features, complex state management, map integrations, analytics, file system management, 
              and building scalable architectures. Every project I build is crafted from the ground up, 
              focusing on performance, user experience, and maintainable code.
            </p>
            <div className="about-stats">
              <div className="stat-item">
                <h3>{yearsExperience}</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat-item">
                <h3>14</h3>
                <p>Published Apps</p>
              </div>
              <div className="stat-item">
                <h3>2</h3>
                <p>NPM Packages</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="about-image"
          >
            <div className="image-wrapper">
              <div className="image-glow"></div>
              <img 
                src="/images/about.webp" 
                alt="Vardges Avetisyan"
                className="about-photo"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default About

